import {environment} from '../../environments/environment';

export const API_URL = environment['API_URL'];
export const API_VERSION = environment['API_VERSION'];
export const AUTH_TOKEN = environment['AUTH_TOKEN'];
export const LOGOUT_URL = environment['LOGOUT_URL'];
